var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9487 2.88789C14.0198 2.95943 14.0735 3.04173 14.1098 3.12954C14.1465 3.21797 14.1667 3.31493 14.1667 3.41663V6.41663C14.1667 6.83084 13.831 7.16663 13.4167 7.16663C13.0025 7.16663 12.6667 6.83084 12.6667 6.41663V5.22729L10.4471 7.44696C10.1542 7.73985 9.67931 7.73985 9.38642 7.44696C9.09352 7.15406 9.09352 6.67919 9.38642 6.3863L11.6061 4.16663H10.4167C10.0025 4.16663 9.66675 3.83084 9.66675 3.41663C9.66675 3.00241 10.0025 2.66663 10.4167 2.66663H13.4167C13.623 2.66663 13.8099 2.74992 13.9455 2.88471L13.9487 2.88789Z",
    fill: "#565A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94708 8.8863C8.23997 9.17919 8.23997 9.65406 7.94708 9.94696L5.72741 12.1666H6.91675C7.33096 12.1666 7.66675 12.5024 7.66675 12.9166C7.66675 13.3308 7.33096 13.6666 6.91675 13.6666H3.91675C3.81506 13.6666 3.71809 13.6464 3.62966 13.6097C3.54185 13.5734 3.45955 13.5197 3.38801 13.4485L3.38483 13.4454C3.31371 13.3738 3.25999 13.2915 3.22366 13.2037C3.18699 13.1153 3.16675 13.0183 3.16675 12.9166V9.91663C3.16675 9.50241 3.50253 9.16663 3.91675 9.16663C4.33096 9.16663 4.66675 9.50241 4.66675 9.91663V11.106L6.88642 8.8863C7.17931 8.5934 7.65419 8.5934 7.94708 8.8863Z",
    fill: "#565A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.ad0dae8f17335fba4e010484f5d06fad.svg";
export { ForwardRef as ReactComponent };